import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Heading, Image } from "@chakra-ui/react"
import { IFrame } from "../../components"

export default function Header({ title, image, tag }) {
  return (
    <React.Fragment>
      <Heading size="4xl" textAlign="center" mb={8} fontWeight="semibold">
        {title}
      </Heading>
      {tag === "Project" ? (
        <IFrame link="https://storage.net-fs.com/hosting/7165292/0/" />
      ) : (
        <Image
          image={image.childImageSharp.gatsbyImageData}
          layerStyle="foreground"
          as={GatsbyImage}
          alt={title}
        />
      )}
    </React.Fragment>
  )
}
